import React, { useState } from 'react';

function NewPostForm({ onCreate }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [file, setFile] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    if (file) formData.append('file', file);
    onCreate(formData); // send FormData to parent
    setTitle('');
    setContent('');
    setFile(null);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>New Post</h3>
      <div>
        <label>Title:</label>
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
      </div>
      <div>
        <label>Content:</label>
        <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={4} required />
      </div>
      <div>
        <label>Attach Image/Video:</label>
        <input type="file" accept="image/*,video/*" onChange={(e) => setFile(e.target.files[0])} />
      </div>
      <button type="submit">Post</button>
    </form>
  );
}

export default NewPostForm;
